<template>
  <Dialog
    :header="parent ? `Novo subtipo de ${parent.name}` : 'Novo Tipo de Serviço'"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :breakpoints="{ '960px': '35vw', '640px': '80vw' }"
    :modal="true"
    :closable="false"
  >
    <AppForm
      ref="form"
      :rules="rules"
      :values="serviceType"
      v-slot:default="{ formErrors }"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <AppFormItem :error="formErrors.name" label="Nome">
            <InputText v-model="serviceType.name" />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <AppColorPicker v-model="serviceType.color" />
          <span style="margin-left: 7px">Cor do tipo</span>
        </div>
        <div class="p-field p-col-12 p-md-12">
          <AppFormItem label="Descrição">
            <Textarea v-model="serviceType.description" rows="3" />
          </AppFormItem>
        </div>
      </div>
    </AppForm>
    <template #footer>
      <div class="p-grid p-jc-between">
        <div class="p-ml-2">
          <Checkbox
            name="calcChildBirth"
            v-model="serviceType.calcChildBirth"
            :binary="true"
          />
          <label class="p-ml-2" for="calcChildBirth">Calcular previsão de parto</label>
        </div>
        <div style="padding-right: 8px">
          <Button
            label="Cancelar"
            class="p-button-outlined p-mr-2"
            @click="$emit('update:visible', false)"
          />
          <AppButton label="Salvar" @click="save()" :loading="loadingSave" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { ServiceTypeApi } from '../../../services/api';

export default {
  name: 'ServiceTypeEdit',
  props: {
    visible: Boolean,
    parent: Object,
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
      },
      loadingSave: false,
      serviceTypes: [],
      serviceType: {
        name: '',
        color: '#0075FF',
        description: '',
        calcChildBirth: false,
      },
    };
  },
  async created() {
    const serviceTypes = await ServiceTypeApi.fetch();
    this.serviceTypes = serviceTypes.results;
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.resetData();
      }
    },
  },
  methods: {
    resetData() {
      this.serviceType = {
        name: '',
        color: '#0075FF',
        description: '',
      };
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      });
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.loadingSave = true;
        const color = (this.serviceType.color || '').startsWith('#')
          ? this.serviceType.color
          : `#${this.serviceType.color}`;
        const body = {
          ...this.serviceType,
          color,
          parentId: this.parent?.id || null,
        };
        await ServiceTypeApi.create(body);
        this.$emit('save');
        this.$emit('update:visible', false);
        this.resetData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingSave = false;
      }
    },
    handleError(error) {
      console.log(error);
      let detail = 'Não foi possível salvar o tipo de serviço.';
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe!',
        detail,
        life: 3000,
      });
    },
  },
};
</script>

<style scoped>
.p-colorpicker {
  margin-top: 23px;
}
</style>
